/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    export class FormDataService {

        constructor(private $q: angular.IQService, private $http: angular.IHttpService) {

        }

        public createFormData(processId: string, formId: string, parentFormDataId?: string): angular.IPromise<string> {
            var d = this.$q.defer();

            let url = './api/Process/' + processId + '/Form/' + formId;

            if (parentFormDataId) {
                url += '/Parent/' + parentFormDataId;
            }

            this.$http.post(url, null)
                .then(result => {
                    d.resolve(result.data);
                });

            return d.promise;
        }

        public setFormField(processId: string,
            formId: string,
            formDataId: string,
            fieldUniqueIdentifer: string,
            value: string): angular.IPromise<any> {
            var d = this.$q.defer();

            let data = {
                val: value
            };

            this.$http.post('./api/Process/' +
                    processId +
                    '/Form/' +
                    formId +
                    "/" +
                    formDataId +
                    "/Field/" +
                    fieldUniqueIdentifer,
                    data)
                .then(result => {
                    d.resolve(result.data);
                });

            return d.promise;
        }

        public clearFormData(processId: string, formId: string, formDataId: string): angular.IPromise<any> {
            var d = this.$q.defer();

            this.$http.post('./api/Process/' + processId + '/Form/' + formId + "/" + formDataId + "/Clear/", null)
                .then(result => {
                    d.resolve();
                });

            return d.promise;
        }

        public addListRow(processId: string,
            formId: string,
            formDataId: string,
            listUniqueIdentifer: string,
            rowId: string,
            onlyAllowApiEdits?: boolean): angular.IPromise<any> {
            var d = this.$q.defer();

            let metadata = null;

            if (onlyAllowApiEdits) {
                metadata = {
                    onlyAllowApiEdits: onlyAllowApiEdits
                };
            }

            this.$http.post('./api/Process/' +
                    processId +
                    '/Form/' +
                    formId +
                    "/" +
                    formDataId +
                    "/Group/" +
                    listUniqueIdentifer +
                    "/Row/" +
                    rowId,
                    metadata)
                .then(result => {
                    d.resolve(result);
                });

            return d.promise;
        }

        public removeListRow(processId: string,
            formId: string,
            formDataId: string,
            listUniqueIdentifer: string,
            rowId: string): angular.IPromise<any> {
            var d = this.$q.defer();

            this.$http.post('./api/Process/' +
                    processId +
                    '/Form/' +
                    formId +
                    "/" +
                    formDataId +
                    "/Group/" +
                    listUniqueIdentifer +
                    "/Row/" +
                    rowId +
                    '/Delete',
                    {})
                .then(result => {
                    d.resolve(result);
                });

            return d.promise;
        }

        public setMultipleListFields(processId: string,
            formId: string,
            formDataId: string,
            listUniqueIdentifer: string,
            rowId: string,
            multiAddFieldsSaveDto: Wars.Domain.Model.Dtos.MultiAddFieldsSaveDto): angular.IPromise<any> {
            var d = this.$q.defer();

            this.$http.post('./api/Process/' +
                    processId +
                    '/Form/' +
                    formId +
                    "/" +
                    formDataId +
                    "/Group/" +
                    listUniqueIdentifer +
                    "/Row/" +
                rowId + '/SaveMultiAddFields',
                    multiAddFieldsSaveDto)
                .then(result => {
                    d.resolve(result.data);
                });

            return d.promise;
        }

        public setListField(processId: string,
            formId: string,
            formDataId: string,
            listUniqueIdentifer: string,
            rowId: string,
            fieldUniqueIdentifer: string,
            value: string,
            isReadOnly?:boolean): angular.IPromise<any> {
            var d = this.$q.defer();

            let data = {
                val: value,
                metadata:""
            };

            if (isReadOnly) {
                data.metadata= JSON.stringify({
                    isReadonly: true
                });
            }

            this.$http.post('./api/Process/' +
                    processId +
                    '/Form/' +
                    formId +
                    "/" +
                    formDataId +
                    "/Group/" +
                    listUniqueIdentifer +
                    "/Row/" +
                    rowId +
                    "/Property/" +
                    fieldUniqueIdentifer,
                    data)
                .then(result => {
                    d.resolve(result.data);
                });

            return d.promise;
        }

        public calculate(processId: string, calculationId: string): angular.IPromise<any> {
            var d = this.$q.defer();

            this.$http.post('./api/Process/' + processId + '/Calculate/' + calculationId, null)
                .then(result => {
                    d.resolve(result.data);
                });

            return d.promise;
        }
    }
}

warsApp.registerService('FormDataService', ['$q', '$http'])